<!-- src/app/views/pericia/dialog-form-pericia/dialog-form-pericia.component.html -->
<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} Pericia</strong></h2>

<!-- Spinners para diferentes operaciones -->
<ngx-spinner [zIndex]="100" name="spCrearPericia" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<ngx-spinner [zIndex]="100" name="spModificarPericia" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<ngx-spinner [zIndex]="100" name="spEliminarPericia" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">

  <form [formGroup]="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      <div class="delete-confirmation">
        <mat-icon class="warning-icon">warning</mat-icon>
        <p>¿Está seguro que desea eliminar la pericia <strong>{{data.descripcion}}</strong>?</p>
        <p class="delete-warning">Esta acción no se puede deshacer.</p>
      </div>
    </ng-container>

    <ng-template #formTemplate>
      <mat-tab-group class="form-tabs" animationDuration="300ms">

        <!-- Tab 1: Información Básica -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">info</mat-icon>
            Información Básica
          </ng-template>

          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>title</mat-icon>
              </div>
              <mat-card-title>Información Básica</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div class="row">
                <div class="col-sm-12 col-md-8">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Descripción</mat-label>
                    <input placeholder="Descripción de la pericia" type="text" formControlName="Descripcion" matInput />
                    <mat-error *ngIf="f.Descripcion.errors?.['required']">Este campo es
                      <strong>requerido</strong>.</mat-error>
                    <mat-error *ngIf="f.Descripcion.errors?.['maxlength']">Máximo 500 caracteres.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-4">
                  <mat-slide-toggle formControlName="Activo" color="primary" class="w-100">
                    <span class="toggle-label">Activo</span>
                  </mat-slide-toggle>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Lugar</mat-label>
                    <input matInput [formControl]="lugarControl" [matAutocomplete]="autoLugar"
                      placeholder="Seleccione o escriba un lugar">
                    <mat-autocomplete #autoLugar="matAutocomplete">
                      <mat-option *ngFor="let lugar of filteredLugares | async" [value]="lugar">
                        {{ lugar }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-hint>Seleccione de la lista o escriba uno nuevo</mat-hint>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>URL de Reunión</mat-label>
                    <input placeholder="https://..." type="url" formControlName="UrlReunion" matInput />
                    <mat-hint>Para reuniones virtuales</mat-hint>
                    <mat-error *ngIf="f.UrlReunion.errors?.['maxlength']">Máximo 500 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Observaciones</mat-label>
                    <textarea placeholder="Observaciones adicionales" formControlName="Observaciones" matInput
                      rows="4"></textarea>
                    <mat-error *ngIf="f.Observaciones.errors?.['maxlength']">Máximo 1000 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

        <!-- Tab 2: Fechas -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">event</mat-icon>
            Fechas
          </ng-template>

          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>schedule</mat-icon>
              </div>
              <mat-card-title> Fechas Principales</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Propuesta</mat-label>
                    <input matInput [matDatepicker]="pickerPropuesta" formControlName="FechaPropuesta"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerPropuesta"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPropuesta></mat-datepicker>
                    <mat-error *ngIf="f.FechaPropuesta.errors?.['required']">Este campo es
                      <strong>requerido</strong>.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Realizada</mat-label>
                    <input matInput [matDatepicker]="pickerRealizada" formControlName="FechaRealizada"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerRealizada"></mat-datepicker-toggle>
                    <mat-datepicker #pickerRealizada></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Finalizada</mat-label>
                    <input matInput [matDatepicker]="pickerFinalizada" formControlName="FechaFinalizada"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerFinalizada"></mat-datepicker-toggle>
                    <mat-datepicker #pickerFinalizada></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>access_time</mat-icon>
              </div>
              <mat-card-title> Fechas de Proceso</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Propone Pericia</mat-label>
                    <input matInput [matDatepicker]="pickerPropone" formControlName="FechaProponePericia"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerPropone"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPropone></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Realiza Pericia</mat-label>
                    <input matInput [matDatepicker]="pickerRealiza" formControlName="FechaRealizaPericia"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerRealiza"></mat-datepicker-toggle>
                    <mat-datepicker #pickerRealiza></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

        <!-- Tab 3: Estado y Configuración -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">settings</mat-icon>
            Estado y Configuración
          </ng-template>

          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>settings</mat-icon>
              </div>
              <mat-card-title> Estado y Configuración</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <ngx-spinner [zIndex]="-1" name="spBusquedaTiposPericia" bdColor="rgba(255,255,255,0.8)"
                      size="small" color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                    <mat-label>Tipo de Pericia</mat-label>
                    <mat-select placeholder="Seleccione un tipo" formControlName="IdTipoPericia">
                      <mat-option [value]="tipo.id"
                        *ngFor="let tipo of tiposPericia; let i = index; trackBy: trackByItems">
                        {{ tipo.descripcion }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="f.IdTipoPericia.errors?.['required']">Este campo es
                      <strong>requerido</strong>.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <ngx-spinner [zIndex]="-1" name="spBusquedaEstados" bdColor="rgba(255,255,255,0.8)" size="small"
                      color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                    <mat-label>Estado de Pericia</mat-label>
                    <mat-select placeholder="Seleccione un estado" formControlName="IdEstadoPericia">
                      <mat-option [value]="estado.id"
                        *ngFor="let estado of estadosPericia; let i = index; trackBy: trackByItems">
                        {{ estado.descripcion }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="f.IdEstadoPericia.errors?.['required']">Este campo es
                      <strong>requerido</strong>.</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <ngx-spinner [zIndex]="-1" name="spBusquedaEmpresas" bdColor="rgba(255,255,255,0.8)" size="small"
                      color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                    <mat-label>Empresa</mat-label>
                    <mat-select placeholder="Seleccione una empresa" formControlName="IdEmpresa">
                      <mat-option [value]="empresa.id"
                        *ngFor="let empresa of empresas; let i = index; trackBy: trackByItems">
                        {{ empresa.descripcion }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

        <!-- Tab 4: Notificaciones -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">notifications</mat-icon>
            Notificaciones
          </ng-template>

          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>notification_important</mat-icon>
              </div>
              <mat-card-title> Estado de Notificación</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>


            <mat-card-content>
 <div class="row">
              <div class="col-sm-12">
                <mat-slide-toggle formControlName="NotificacionRealizada" color="primary">
                  <span class="toggle-label">Notificación Realizada</span>
                </mat-slide-toggle>
                <p class="form-hint">Marque si ya se ha realizado la notificación correspondiente</p>
              </div>
            </div>
            </mat-card-content>
          </mat-card>


          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>description</mat-icon>
              </div>
              <mat-card-title>Fechas de Cédulas</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>


            <mat-card-content>
              <div class="row">
              <div class="col-sm-12">
                <mat-slide-toggle formControlName="NotificacionRealizada" color="primary">
                  <span class="toggle-label">Notificación Realizada</span>
                </mat-slide-toggle>
                <p class="form-hint">Marque si ya se ha realizado la notificación correspondiente</p>
              </div>
            </div>
              <div class="row">
                <div class="col-sm-12 col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Cédula Presentación</mat-label>
                    <input matInput [matDatepicker]="pickerCedPresentacion" formControlName="FechaCedulaPresentacion"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerCedPresentacion"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCedPresentacion></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Vence Presentación</mat-label>
                    <input matInput [matDatepicker]="pickerVencePresentacion" formControlName="FechaVencePresentacion"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerVencePresentacion"></mat-datepicker-toggle>
                    <mat-datepicker #pickerVencePresentacion></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Acepta Cargo</mat-label>
                    <input matInput [matDatepicker]="pickerAceptaCargo" formControlName="FechaAceptaCargo"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerAceptaCargo"></mat-datepicker-toggle>
                    <mat-datepicker #pickerAceptaCargo></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

        </mat-tab>

      </mat-tab-group>
    </ng-template>
  </form>

</mat-dialog-content>

<!-- Vista de solo lectura -->
<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">
  <div *ngIf="data" >
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" dynamicHeight>

      <!-- Tab 1: Información General -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">info</mat-icon>
          General
        </ng-template>

        <mat-card>
          <mat-card-content>
            <div class="row">
              <div class="col">
                <mat-card>
                  <mat-card-header>
                    <div mat-card-avatar>
                      <mat-icon>title</mat-icon>
                    </div>
                    <mat-card-title>Información Básica</mat-card-title>
                    <mat-card-subtitle></mat-card-subtitle>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="property-row">
                      <span class="property-name">Descripción:</span>
                      <span class="property-value">{{ data.descripcion | titlecase }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Observaciones:</span>
                      <span class="property-value">{{ data.observaciones | titlecase }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Lugar:</span>
                      <span class="property-value">{{ data.lugar | titlecase }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">URL Reunión:</span>
                      <span class="property-value">{{ data.urlReunion }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Estado:</span>
                      <span class="property-value">{{ data.activo ? 'Activo' : 'Inactivo' }}</span>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
              <div class="col">
                <mat-card appearance="outlined">
                  <mat-card-header>
                    <mat-card-title>Configuración</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="property-row">
                      <span class="property-name">Tipo de Pericia:</span>
                      <span class="property-value">{{ data.tipoPericia?.descripcion | titlecase }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Estado de Pericia:</span>
                      <span class="property-value">{{ data.estadoPericia?.descripcion | titlecase }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Empresa:</span>
                      <span class="property-value">{{ data.empresa?.descripcion | titlecase }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Notificación:</span>
                      <span class="property-value">{{ data.notificacionRealizada ? 'Realizada' : 'Pendiente' }}</span>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>



      </mat-tab>

      <!-- Tab 2: Fechas -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">event</mat-icon>
          Fechas
        </ng-template>
        <mat-card>
          <mat-card-content>
            <div class="row">
            <div class="col-sm-12 col-md-6">
              <mat-card appearance="outlined" >
                <mat-card-header>
                  <mat-card-title>Fechas Principales</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <span class="property-name">Fecha Propuesta:</span>
                    <span class="property-value">{{ data.fechaPropuesta | date:'dd/MM/yyyy' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Fecha Realizada:</span>
                    <span class="property-value">{{ data.fechaRealizada | date:'dd/MM/yyyy' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Fecha Finalizada:</span>
                    <span class="property-value">{{ data.fechaFinalizada | date:'dd/MM/yyyy' }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <div class="col-sm-12 col-md-6">
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Fechas de Proceso</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <span class="property-name">Fecha Propone Pericia:</span>
                    <span class="property-value">{{ data.fechaProponePericia | date:'dd/MM/yyyy' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Fecha Realiza Pericia:</span>
                    <span class="property-value">{{ data.fechaRealizaPericia | date:'dd/MM/yyyy' }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <mat-card appearance="outlined" class="info-card">
                <mat-card-header>
                  <mat-card-title>Fechas de Cédulas y Notificaciones</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-12 col-md-4">
                      <div class="property-row">
                        <span class="property-name">Fecha Cédula Presentación:</span>
                        <span class="property-value">{{ data.fechaCedulaPresentacion | date:'dd/MM/yyyy' }}</span>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <div class="property-row">
                        <span class="property-name">Fecha Vence Presentación:</span>
                        <span class="property-value">{{ data.fechaVencePresentacion | date:'dd/MM/yyyy' }}</span>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <div class="property-row">
                        <span class="property-name">Fecha Acepta Cargo:</span>
                        <span class="property-value">{{ data.fechaAceptaCargo | date:'dd/MM/yyyy' }}</span>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>

          <!-- Información de Auditoría -->
          <div class="row" *ngIf="data.fechaAlta || data.fechaModificacion">
            <div class="col-sm-12">
              <mat-card appearance="outlined" class="info-card audit-card">
                <mat-card-header>
                  <mat-card-title>Información de Auditoría</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <div class="property-row">
                        <span class="property-name">Fecha de Alta:</span>
                        <span class="property-value">{{ data.fechaAlta | date:'dd/MM/yyyy HH:mm' }}</span>
                      </div>
                      <div class="property-row">
                        <span class="property-name">Creado por:</span>
                        <span class="property-value">{{ data.creadoPor?.descripcion || 'Sistema' }}</span>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div class="property-row">
                        <span class="property-name">Última Modificación:</span>
                        <span class="property-value">{{ data.fechaModificacion | date:'dd/MM/yyyy HH:mm' }}</span>
                      </div>
                      <div class="property-row">
                        <span class="property-name">Modificado por:</span>
                        <span class="property-value">{{ data.modificadoPor?.descripcion }}</span>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
          </mat-card-content>
        </mat-card>
      </mat-tab>

    </mat-tab-group>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>

  <app-button-add *ngIf="data.accion == accionesDialog.Agregar" [disabled]="!form.valid" (click)="agregar()">
  </app-button-add>

  <app-button-save *ngIf="data.accion == accionesDialog.Modificar" [disabled]="!form.valid" [isDialogClose]="true"
    (saveClicked)="modificar()" (cancelClicked)="closeDialog()">
  </app-button-save>

  <app-button-delete *ngIf="data.accion == accionesDialog.Eliminar" (click)="eliminar()" (cancelClicked)="closeDialog()"
    [isDialogClose]="true">
  </app-button-delete>
</mat-dialog-actions>
